<template>
  <div>
    <div
      ref="description"
      :class="[
        style.description,
        showMore ? style.show : '',
        isOverflow && !showMore ? style.ellipsis : ''
      ]"
    >
      <slot></slot>
    </div>
    <span v-if="isOverflow" :class="[style['show-more']]" @click="showMore = !showMore">{{
      showMore ? $t('show_less') : $t('show_more')
    }}</span>
  </div>
</template>

<script>
import style from './scss/_slider.scss'

export default {
  name: 'SliderExpandableBlock',

  data() {
    return {
      style,
      isOverflow: false,
      showMore: false
    }
  },

  mounted() {
    const el = this.$refs['description']
    const lineHeight = parseInt(window.getComputedStyle(el).lineHeight, 10)

    this.isOverflow = el.scrollHeight > lineHeight * 4
  }
}
</script>
